"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Asset_1 = __importDefault(require("./Asset"));

var RpcOffer = /*#__PURE__*/function () {
  function RpcOffer(api, id, data, senderAssets, receiverAssets) {
    var _this = this;

    var cache = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    _classCallCheck(this, RpcOffer);

    this.api = api;
    this.id = id;
    this._data = new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 4;
                  break;
                }

                resolve(data);
                _context.next = 15;
                break;

              case 4:
                _context.prev = 4;
                _context.t0 = resolve;
                _context.next = 8;
                return _this.api.queue.fetchOffer(id, cache);

              case 8:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t2 = _context["catch"](4);
                reject(_context.t2);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this._senderAssets = new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
        var row, inventory;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!senderAssets) {
                  _context2.next = 4;
                  break;
                }

                resolve(senderAssets);
                _context2.next = 17;
                break;

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return _this._data;

              case 7:
                row = _context2.sent;
                _context2.next = 10;
                return _this.api.queue.fetchAccountAssets(row.sender);

              case 10:
                inventory = _context2.sent;
                return _context2.abrupt("return", resolve(row.sender_asset_ids.map(function (assetID) {
                  var asset = inventory.find(function (assetRow) {
                    return assetRow.asset_id === assetID;
                  });
                  return asset ? new Asset_1.default(_this.api, row.sender, assetID, asset, undefined, undefined, undefined, cache) : assetID;
                })));

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](4);
                return _context2.abrupt("return", reject(_context2.t0));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 14]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    this._recipientAssets = new Promise( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
        var row, inventory;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!receiverAssets) {
                  _context3.next = 4;
                  break;
                }

                resolve(receiverAssets);
                _context3.next = 17;
                break;

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return _this._data;

              case 7:
                row = _context3.sent;
                _context3.next = 10;
                return _this.api.queue.fetchAccountAssets(row.recipient);

              case 10:
                inventory = _context3.sent;
                return _context3.abrupt("return", resolve(row.recipient_asset_ids.map(function (assetID) {
                  var asset = inventory.find(function (assetRow) {
                    return assetRow.asset_id === assetID;
                  });
                  return asset ? new Asset_1.default(_this.api, row.recipient, assetID, asset, undefined, undefined, undefined, cache) : assetID;
                })));

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](4);
                return _context3.abrupt("return", reject(_context3.t0));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 14]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }());
  }

  _createClass(RpcOffer, [{
    key: "sender",
    value: function () {
      var _sender = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._data;

              case 2:
                return _context4.abrupt("return", _context4.sent.sender);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sender() {
        return _sender.apply(this, arguments);
      }

      return sender;
    }()
  }, {
    key: "recipient",
    value: function () {
      var _recipient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._data;

              case 2:
                return _context5.abrupt("return", _context5.sent.recipient);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function recipient() {
        return _recipient.apply(this, arguments);
      }

      return recipient;
    }()
  }, {
    key: "senderAssets",
    value: function () {
      var _senderAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._senderAssets;

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function senderAssets() {
        return _senderAssets.apply(this, arguments);
      }

      return senderAssets;
    }()
  }, {
    key: "recipientAssets",
    value: function () {
      var _recipientAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._recipientAssets;

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function recipientAssets() {
        return _recipientAssets.apply(this, arguments);
      }

      return recipientAssets;
    }()
  }, {
    key: "memo",
    value: function () {
      var _memo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._data;

              case 2:
                return _context8.abrupt("return", _context8.sent.memo);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function memo() {
        return _memo.apply(this, arguments);
      }

      return memo;
    }()
  }, {
    key: "toObject",
    value: function () {
      var _toObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.t0 = this.id;
                _context11.next = 3;
                return this.sender();

              case 3:
                _context11.t1 = _context11.sent;
                _context11.t2 = Promise;
                _context11.next = 7;
                return this.senderAssets();

              case 7:
                _context11.t3 = _context11.sent.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(asset) {
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (!(typeof asset === 'string')) {
                              _context9.next = 4;
                              break;
                            }

                            _context9.t0 = asset;
                            _context9.next = 7;
                            break;

                          case 4:
                            _context9.next = 6;
                            return asset.toObject();

                          case 6:
                            _context9.t0 = _context9.sent;

                          case 7:
                            return _context9.abrupt("return", _context9.t0);

                          case 8:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x7) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context11.next = 10;
                return _context11.t2.all.call(_context11.t2, _context11.t3);

              case 10:
                _context11.t4 = _context11.sent;
                _context11.t5 = {
                  account: _context11.t1,
                  assets: _context11.t4
                };
                _context11.next = 14;
                return this.recipient();

              case 14:
                _context11.t6 = _context11.sent;
                _context11.t7 = Promise;
                _context11.next = 18;
                return this.recipientAssets();

              case 18:
                _context11.t8 = _context11.sent.map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(asset) {
                    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            if (!(typeof asset === 'string')) {
                              _context10.next = 4;
                              break;
                            }

                            _context10.t0 = asset;
                            _context10.next = 7;
                            break;

                          case 4:
                            _context10.next = 6;
                            return asset.toObject();

                          case 6:
                            _context10.t0 = _context10.sent;

                          case 7:
                            return _context10.abrupt("return", _context10.t0);

                          case 8:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                _context11.next = 21;
                return _context11.t7.all.call(_context11.t7, _context11.t8);

              case 21:
                _context11.t9 = _context11.sent;
                _context11.t10 = {
                  account: _context11.t6,
                  assets: _context11.t9
                };
                _context11.next = 25;
                return this.memo();

              case 25:
                _context11.t11 = _context11.sent;
                return _context11.abrupt("return", {
                  offer_id: _context11.t0,
                  sender: _context11.t5,
                  recipient: _context11.t10,
                  memo: _context11.t11
                });

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function toObject() {
        return _toObject.apply(this, arguments);
      }

      return toObject;
    }()
  }]);

  return RpcOffer;
}();

exports.default = RpcOffer;